import { Trash2, Play } from "lucide-react";
import { fmtTime, CATEGORY_COLORS } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const HighlightList = ({ highlights, activeId, onPick, onDelete }) => {
  const { t } = useI18n();
  if (!highlights.length)
    return <div className="text-sm text-slate-500 p-6 text-center border border-dashed border-white/10 rounded-xl" data-testid="highlights-empty">{t("ed.no_highlights")}</div>;
  return (
    <div className="space-y-2.5 max-h-[520px] overflow-y-auto cx-scroll pr-1" data-testid="highlights-list">
      {highlights.map((h) => {
        const c = CATEGORY_COLORS[h.category] || "#a746ff";
        return (
          <div key={h.id} data-testid="highlight-item" onClick={() => onPick(h)}
            className={`group rounded-xl p-3 sm:p-4 border cursor-pointer transition-colors duration-200 ${activeId === h.id ? "border-[#3ad7ff]/60 bg-[#2f7bff]/10" : "border-white/5 bg-white/[0.02] hover:border-white/15"}`}>
            <div className="flex items-start gap-3">
              <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-lg grid place-items-center font-display font-bold text-lg shrink-0" style={{ background: `${c}22`, color: c, border: `1px solid ${c}55` }} data-testid="highlight-score">{h.score}</div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded" style={{ background: `${c}22`, color: c }}>{t(`cat.${h.category}`)}</span>
                  <span className="font-mono text-[11px] text-slate-500">{fmtTime(h.start)} → {fmtTime(h.end)}</span>
                </div>
                <div className="font-display font-semibold text-white mt-1 truncate">{h.label}</div>
                {h.reason && <div className="text-xs text-slate-400 mt-1 line-clamp-2">{h.reason}</div>}
              </div>
              <div className="flex flex-col gap-2 opacity-70 group-hover:opacity-100 transition-opacity">
                <Play className="w-4 h-4 text-[#3ad7ff]" />
                <button data-testid="highlight-delete-btn" onClick={(e) => { e.stopPropagation(); onDelete(h); }} className="text-slate-500 hover:text-rose-400"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
